function initialize() {
    const selectLang = document.querySelectorAll('.select-lang');
    if (!selectLang) {
        return;
    }
    selectLang.forEach(function (selLang) {
        selLang.addEventListener('click', function (evt) {
            // evt.preventDefault();
            // evt.stopPropagation();
            selLang.classList.toggle('is-open');
        });
    });

    // const langLinks = document.querySelectorAll('.list-lang a');
    // langLinks.forEach(function (link) {
    //     link.addEventListener('click', function (evt) {
    //         evt.preventDefault();
    //         evt.stopImmediatePropagation();
    //         selectLanguage(link.getAttribute('data-lang'));
    //     });
    // });

    // document.body.addEventListener('click', function () {
    //     selectLang.forEach(function (selLang) {
    //         selLang.classList.remove('is-open');
    //     });
    // });
}

// function selectLanguage(lang) {
//     var hrefLang = document.querySelector('link[data-lang="' + lang + '"]');

//     if (hrefLang) {
//         window.location = hrefLang.getAttribute('href');
//     } else if (lang == 'pt_BR') {
//         window.location = base_url;
//     } else {
//         window.location = base_url + lang;
//     }
// }

initialize();
